import { render, staticRenderFns } from "./modalEdit.vue?vue&type=template&id=87784742&scoped=true"
import script from "./modalEdit.vue?vue&type=script&lang=js"
export * from "./modalEdit.vue?vue&type=script&lang=js"
import style0 from "./modalEdit.vue?vue&type=style&index=0&id=87784742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87784742",
  null
  
)

export default component.exports